module.exports = __webpack_public_path__ + "static/media/elec.02d132d7.svg";